import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-email-settings-layout',
  templateUrl: './email-settings-layout.component.html',
  styleUrls: ['./email-settings-layout.component.css']
})
export class EmailSettingsLayoutComponent implements OnInit {

  @Input() title: string;
  @Input() viewMode;

  constructor() { }

  ngOnInit() {
  }

}
